import { useMutation, useQuery } from '@tanstack/react-query';
import fetchWrapper from '@http/fetchWrapper';
import { api } from '@http/constants';
import type { I18nReleaseLockState } from '@eye-able/types';

export const useReleaseActions = () => {
  const lockStatusAction = useQuery({
    retry: false,
    queryKey: [api.i18nReleaseLock],
    queryFn: () => fetchWrapper.get<I18nReleaseLockState>(api.i18nReleaseLock),
    refetchInterval: () => 3000,
  });

  const lockReleaseAction = useMutation({
    retry: false,
    mutationFn: () =>
      fetchWrapper.post<I18nReleaseLockState>(api.i18nReleaseLock, {}),
  });

  const unlockReleaseAction = useMutation({
    retry: false,
    mutationFn: () =>
      fetchWrapper.post<I18nReleaseLockState>(api.i18nReleaseUnlock, {}),
  });

  const releaseAction = useMutation({
    retry: false,
    mutationFn: (version: string) =>
      fetchWrapper.post<void>(api.i18nRelease, {
        version,
      }),
  });

  return {
    lockStatusAction,
    lockReleaseAction,
    unlockReleaseAction,
    releaseAction,
  };
};
